// Copyright (c) 2025 Murr (https://github.com/vtstv)
// path: src/web/frontend/src/i18n/locales/ru.ts

export const ru = {
  common: {
    loading: 'Загрузка...',
    initializing: 'Инициализация...',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    back: 'Назад',
    confirm: 'Подтвердить',
    search: 'Поиск',
    filter: 'Фильтр',
    refresh: 'Обновить',
    updating: 'Обновление...',
    goBack: 'Вернуться',
    viewAll: 'Показать все',
    noData: 'Нет данных',
    of: 'из',
  },
  nav: {
    dashboard: 'Панель управления',
    events: 'События',
    templates: 'Шаблоны',
    settings: 'Настройки',
    calendar: 'Календарь',
    compositions: 'Составы',
  },
  dashboard: {
    title: 'Панель управления',
    subtitle: 'Обзор событий и статистики вашего сервера',
    loadingDashboard: 'Загрузка панели управления...',
    createEvent: 'Создать событие',
    quickAccess: 'Быстрый доступ',
    stats: {
      totalEvents: 'Всего событий',
      activeEvents: 'Активные события',
      templates: 'Шаблоны',
      totalParticipants: 'Всего участников',
    },
    quickActions: {
      viewAllEvents: 'Все события',
      viewAllEventsDesc: 'Управление событиями сервера',
      eventCalendar: 'Календарь событий',
      eventCalendarDesc: 'Просмотр событий в формате календаря',
    },
  },
  events: {
    title: 'События',
    event: 'событие',
    events: 'событий',
    showing: 'Показано',
    eventsFound: 'событий найдено',
    loadingEvents: 'Загрузка событий...',
    createEvent: 'Создать событие',
    searchPlaceholder: 'Поиск событий по названию или описанию...',
    filters: {
      all: 'Все события',
      scheduled: 'Запланированные',
      active: 'Активные',
      completed: 'Завершённые',
      cancelled: 'Отменённые',
      dateRange: 'Диапазон дат',
      startDate: 'Начальная дата',
      endDate: 'Конечная дата',
      showFilters: 'Показать фильтры',
      hideFilters: 'Скрыть фильтры',
      clearFilters: 'Очистить фильтры',
    },
    status: {
      scheduled: 'Запланировано',
      active: 'Активно',
      completed: 'Завершено',
      cancelled: 'Отменено',
    },
    noEvents: 'События не найдены',
    noEventsDesc: 'Создайте первое событие для начала работы',
    viewDetails: 'Подробнее',
    participants: 'Участники',
    startTime: 'Время начала',
  },
  eventDetails: {
    title: 'Детали события',
    loading: 'Загрузка события...',
    loadingDetails: 'Загрузка деталей события...',
    backToEvents: 'Назад к событиям',
    backButton: 'Назад к событиям',
    edit: 'Редактировать событие',
    composition: 'Компоновка',
    fullEdit: 'Полное редактирование',
    participants: 'Участники',
    description: 'Описание',
    startTime: 'Время начала',
    maxParticipants: 'Макс. участников',
    unlimited: 'Неограничено',
    status: 'Статус',
    template: 'Шаблон',
    noDescription: 'Описание не предоставлено',
    noDescriptionPlaceholder: 'Нет описания (нажмите для добавления)',
    notFound: 'Событие не найдено',
    notFoundDesc: 'Это событие могло быть удалено',
    deleteConfirm: 'Вы уверены, что хотите удалить это событие?',
    clickToEdit: 'Нажмите для редактирования',
    saving: 'Сохранение...',
    save: 'Сохранить',
    cancel: 'Отмена',
    failedToUpdate: 'Не удалось обновить',
    failedToDelete: 'Не удалось удалить событие',
    createdBy: 'Создано',
    createdAt: 'Дата создания',
    statistics: 'Статистика',
  },
  createEvent: {
    title: 'Создать событие',
    titleEdit: 'Редактировать событие',
    subtitle: 'Заполните детали для создания нового события',
    subtitleEdit: 'Обновите детали события',
    backToEvents: 'Назад к событиям',
    save: 'Создать событие',
    saveEdit: 'Обновить событие',
    loadFailed: 'Не удалось загрузить каналы и шаблоны',
    cancel: 'Отмена',
    createButton: 'Создать событие',
    updateButton: 'Обновить событие',
    creating: 'Создание...',
    updating: 'Обновление...',
    fields: {
      title: 'Название события',
      titlePlaceholder: 'Еженедельный рейд',
      description: 'Описание',
      descriptionPlaceholder: 'Присоединяйтесь к нашему еженедельному рейду...',
      startTime: 'Время начала',
      maxParticipants: 'Макс. участников',
      maxParticipantsHint: '(0 = без ограничений)',
      maxParticipantsPlaceholder: '25',
      channel: 'Канал',
      channelRequired: 'обязательно',
      loadingChannels: 'Загрузка каналов...',
      selectChannel: 'Выберите канал',
      noChannels: 'Текстовые каналы не найдены. Проверьте разрешения бота.',
      channelHint: 'Сообщение о событии будет опубликовано в этом канале',
      template: 'Шаблон (опционально)',
      loadingTemplates: 'Загрузка шаблонов...',
      noTemplate: 'Без шаблона',
      templateHint: 'Применить роли, лимиты и настройки из шаблона',
    },
  },
  createTemplate: {
    title: 'Создать шаблон',
    titleEdit: 'Редактировать шаблон',
    subtitle: 'Создайте многоразовый шаблон для событий',
    subtitleEdit: 'Обновите настройки шаблона события',
    backToTemplates: 'Назад к шаблонам',
    save: 'Создать шаблон',
    saveEdit: 'Обновить шаблон',
    loadFailed: 'Не удалось загрузить шаблон',
    cancel: 'Отмена',
    createButton: 'Создать шаблон',
    updateButton: 'Обновить шаблон',
    creating: 'Создание...',
    updating: 'Обновление...',
    fields: {
      name: 'Название шаблона',
      namePlaceholder: 'Мифик+ забег',
      maxParticipants: 'Макс. участников',
      maxParticipantsHint: '(0 = без ограничений)',
      maxParticipantsPlaceholder: '5',
      description: 'Описание',
      descriptionPlaceholder: 'Стандартный шаблон для подземелий Мифик+',
      allowedRoles: 'Доступные роли',
      allowedRolesPlaceholder: 'Танк, Хилер, ДД',
      allowedRolesHint: 'Список ролей через запятую',
      roleLimits: 'Лимиты ролей (опционально)',
      roleLimitsPlaceholder: 'Танк:2, Хилер:5, ДД:18',
      roleLimitsHint: 'Формат: Роль:лимит, Роль:лимит (пары через запятую)',
      emojiMapping: 'Соответствие эмодзи',
      emojiMappingPlaceholder: 'Танк:🛡️, Хилер:❤️, ДД:⚔️',
      emojiMappingHint: 'Формат: Роль:Эмодзи, Роль:Эмодзи (пары через запятую)',
      imageUrl: 'URL изображения (опционально)',
      imageUrlPlaceholder: 'https://example.com/image.png',
      imageUrlHint: 'Добавить баннер к embed сообщениям, созданным из этого шаблона',
    },
    help: {
      title: 'Советы по шаблонам',
      tip1: 'Шаблоны можно переиспользовать для нескольких событий',
      tip2: 'Доступные роли помогают участникам выбрать свою позицию',
      tip3: 'Соответствие эмодзи делает регистрацию более наглядной и интересной',
      tip4: 'Установите макс. участников для контроля размера группы',
    },
    presets: {
      title: 'Быстрые шаблоны',
    },
  },
  templates: {
    title: 'Шаблоны событий',
    templatesConfigured: 'шаблонов настроено',
    loadingTemplates: 'Загрузка шаблонов...',
    createTemplate: 'Создать шаблон',
    noTemplates: 'Шаблоны не найдены',
    noTemplatesDesc: 'Создайте шаблоны для быстрой настройки повторяющихся событий',
    deleteConfirm: 'Вы уверены, что хотите удалить этот шаблон?',
    deleteFailed: 'Не удалось удалить шаблон',
    created: 'Создан',
    roles: 'Роли',
    roleLimit: 'Лимит роли',
    rolesConfigured: 'ролей настроено',
    maxParticipants: 'Макс. участников',
    edit: 'Редактировать',
    delete: 'Удалить',
  },
  settings: {
    title: 'Настройки',
    subtitle: 'Настройте параметры вашего сервера',
    loadingSettings: 'Загрузка настроек...',
    saveSettings: 'Сохранить настройки',
    savingSettings: 'Сохранение...',
    saveSuccess: '✅ Настройки успешно сохранены!',
    saveFailed: '❌ Не удалось сохранить настройки',
    selectAChannel: 'Выберите канал...',
    archiveAfterHours: 'Архивировать через (часы)',
    add: 'Добавить',
    clearAllRoles: 'Очистить все роли',
    moduleAccessPermissions: 'Доступ к модулям',
    managerHasFullAccess: 'Роль менеджера имеет полный доступ ко всем модулям независимо от этих настроек',
    eventsModule: '📅 События',
    compositionsModule: '⚔️ Компоновки',
    templatesModule: '📋 Шаблоны',
    settingsModule: '⚙️ Настройки',
    sections: {
      languageTimezone: 'Язык и часовой пояс',
      managerAccess: 'Доступ менеджеров',
      automation: 'Автоматизация',
      channels: 'Каналы',
      statistics: 'Статистика',
      participantNotes: 'Заметки об участниках',
    },
    language: {
      title: 'Язык',
      description: 'Выберите предпочитаемый язык',
      en: 'English',
      ru: 'Русский',
      de: 'Deutsch',
    },
    timezone: {
      title: 'Часовой пояс',
      description: 'Установите часовой пояс вашего сервера',
      selectTimezone: 'Выберите часовой пояс вашего сервера. События будут отображаться в этом часовом поясе.',
      currentTime: 'Текущее время',
    },
    managerRoles: {
      title: 'Роли менеджеров',
      description: 'Выберите роли, которые могут управлять событиями и настройками',
      noRoles: 'Роли не выбраны',
      permissions: 'Разрешения',
      canAccessEvents: 'Доступ к событиям',
      canAccessCompositions: 'Доступ к составам',
      canAccessTemplates: 'Доступ к шаблонам',
      canAccessSettings: 'Доступ к настройкам',
      managerRole: 'Роль менеджера',
      noManagerRole: '-- Нет роли менеджера --',
      dashboardAccessRoles: 'Роли доступа к панели управления',
      dashboardAccessHint: 'Выберите роли, которые могут получить доступ к панели управления. Если пусто, доступ только у менеджеров.',
      currentRoles: 'Текущие роли:',
      selectRoleToAdd: 'Выберите роль для добавления',
      addRole: 'Добавить',
      allPages: 'Все страницы',
    },
    automation: {
      autoArchive: 'Автоматическая архивация завершенных событий',
      autoArchiveDesc: 'Автоматически архивировать события после завершения',
      enableReminders: 'Включить напоминания о событиях',
      enableRemindersDesc: 'Отправлять напоминания перед началом событий',
      reminderTime: 'Время напоминания (часов до события)',
      reminderIntervals: 'Интервалы напоминаний',
      reminderIntervalsHint: 'Часы до события через запятую',
      reminderIntervalsPlaceholder: '24, 1',
      dmReminders: 'DM-напоминания',
      dmRemindersDesc: 'Отправлять личные сообщения подтвержденным участникам перед событиями',
      logRetention: 'Хранение логов (дней)',
      logRetentionHint: 'Сколько хранить логи аудита (0 = всегда)',
      logRetentionPlaceholder: '30',
    },
    channels: {
      defaultChannel: 'Канал событий по умолчанию',
      defaultChannelDesc: 'Канал по умолчанию для публикации событий',
      logChannel: 'Канал логов',
      loggingChannel: 'Канал логов',
      logChannelDesc: 'Канал для журнала аудита',
      loggingChannelHint: 'Канал для журнала аудита',
      archiveChannel: 'Канал архива',
      archiveChannelDesc: 'Канал для архивных событий',
      selectChannel: 'Выберите канал',
      selectChannelOption: '-- Выберите канал --',
      archiveAfterHours: 'Архивировать после (часов)',
      approvalChannels: 'Каналы с подтверждением',
      approvalChannelsHint: 'Каналы, требующие подтверждения менеджера',
      threadChannels: 'Каналы с треды',
      threadChannelsHint: 'Каналы, где создаются треды для событий',
    },
    statistics: {
      enableStats: 'Включить статистику',
      enableStatsDesc: 'Отслеживать и отображать статистику сервера',
      enableStatsTracking: 'Включить отслеживание статистики',
      enableTracking: 'Включить отслеживание статистики',
      statsChannel: 'Канал статистики',
      selectChannel: '-- Выберите канал --',
      updateInterval: 'Интервал обновления',
      hourly: 'Каждый час',
      daily: 'Ежедневно',
      weekly: 'Еженедельно',
      monthly: 'Ежемесячно',
      autoRoleTop10: 'Авто-роль для топ-10',
      top10Role: 'Роль топ-10',
      minEventsRequired: 'Мин. требуемых событий',
    },
    participantNotes: {
      enableNotes: 'Включить заметки участников',
      enableNotesDesc: 'Разрешить менеджерам добавлять заметки к участникам',
      notesChannels: 'Каналы заметок',
      notesChannelsDesc: 'Каналы, где видны заметки',
      participantNotes: 'Заметки участников',
      allowParticipantNotes: 'Разрешить заметки участников',
      allowNotes: 'Разрешить заметки участников',
      showViewOnlineButton: 'Показать кнопку \'Посмотреть онлайн\'',
      showViewOnline: 'Показать кнопку \'Посмотреть онлайн\'',
      showViewOnlineButtonHint: 'Показывать ссылку на публичный просмотр события в Discord',
      showViewOnlineDesc: 'Показывать ссылку на публичный просмотр события в Discord',
      maxNoteLength: 'Макс. длина заметки',
      maxNoteLengthHint: 'Максимальное количество символов в заметках участников (по умолчанию: 30)',
      maxNoteLengthPlaceholder: '500',
      noteChannels: 'Каналы заметок',
      noteChannelsHint: 'Каналы, где участники могут добавлять заметки к своим записям. Если пусто, заметки разрешены во всех каналах.',
      currentChannels: 'Текущие каналы:',
      selectChannelToAdd: 'Выберите канал для добавления',
      addChannel: 'Добавить',
    },
  },
  calendar: {
    title: 'Календарь событий',
    loading: 'Загрузка календаря...',
    today: 'Сегодня',
    month: 'Месяц',
    week: 'Неделя',
    day: 'День',
    noEvents: 'Нет событий на этот период',
  },
  compositions: {
    title: 'Составы',
    loading: 'Загрузка составов...',
    eventsWithPlans: 'События с планами рейдов',
    noCompositions: 'Составов пока нет',
    noCompositionsDesc: 'Создайте состав для предстоящего события, чтобы увидеть его здесь',
    viewComposition: 'Просмотр состава',
    viewEvents: 'Просмотр событий',
    slotsFilled: 'Занято мест',
    groups: 'группа(ы)',
  },
  compositionTool: {
    title: 'Инструмент составов',
    loading: 'Загрузка...',
    saveComposition: 'Сохранить состав',
    groups: 'Группы',
    bench: 'Скамейка',
    unassigned: 'Не назначено',
    backToEvent: 'Назад к событию',
    saving: 'Сохранение...',
    viewPublicPage: 'Открыть публичную страницу',
    profiles: 'Профили',
    searchParticipants: 'Поиск участников...',
    noMatches: 'Нет совпадений',
    allAssigned: 'Все назначены',
    strategyDescription: 'Описание стратегии',
    editStrategy: 'Редактировать',
    editStrategyDescription: 'Редактировать описание стратегии',
    addStrategy: 'Добавить стратегию',
    saveStrategy: 'Сохранить стратегию',
    cancel: 'Отмена',
    edit: 'Редактировать',
    strategyPlaceholder: 'Опишите вашу рейд-стратегию, механики боссов, назначения игроков и т.д...',
    charactersCount: 'символов',
    characters: 'символов',
    showMore: 'Показать больше',
    showLess: 'Показать меньше',
    noStrategyYet: 'Описания стратегии пока нет. Нажмите "Добавить стратегию", чтобы добавить.',
    strategyPosition: 'Стратегия',
    strategyAbove: 'сверху',
    strategyBelow: 'снизу',
    toggleStrategyPosition: 'Переключить позицию стратегии',
    dragging: 'Перемещение...',
    deleteGroupConfirm: 'Удалить эту группу?',
    addGroup: '+ Добавить группу',
    clickToEditTitle: 'Нажмите для редактирования заголовка',
    defaultTitle: 'Рейдовая компоновка - Событие',
    profilesModal: {
      title: 'Профили компоновки',
      description: 'Сохраните текущую компоновку в профиль и загрузите её позже. Профили сохраняются так, что другие менеджеры этого сервера также могут их использовать.',
      saveProfile: 'Сохранить профиль',
      loadProfile: 'Загрузить профиль',
      profileName: 'Название профиля',
      profileNamePlaceholder: 'Введите название профиля...',
      profileDescription: 'Описание (необязательно)',
      profileDescriptionPlaceholder: 'Добавьте описание...',
      loadingPresets: 'Загрузка профилей...',
      noPresets: 'Профили не найдены. Сначала сохраните один!',
      hasStrategyNotes: 'Есть заметки стратегии',
      groupsCount: 'групп',
      positionsCount: 'позиций',
      deleteConfirm: 'Удалить этот профиль?',
    },
  },
  publicEvent: {
    loading: 'Загрузка события...',
    notFound: 'Событие не найдено',
    notFoundDesc: 'Это событие может не существовать или недоступно публично',
    description: 'Описание',
    participants: 'Участники',
    confirmed: 'Подтверждённые',
    pending: 'Ожидают одобрения',
    waitlist: 'Очередь / Резерв',
    noParticipants: 'Участников пока нет',
    viewRaidPlan: 'Посмотреть план рейда',
    raidPlanAvailable: 'Для этого события доступен план состава рейда',
  },
  nativeEvents: {
    title: 'Нативные Discord события',
    createEvents: 'Создавать Discord события',
    createEventsDescription: 'Автоматически создавать нативные Discord события для ваших ивентов с динамическим обновлением участников',
    benefitsTitle: 'Преимущества нативных Discord событий:',
    benefit1: 'События видны в календаре Discord сервера',
    benefit2: 'Участники могут отмечаться как "Interested"',
    benefit3: 'Автоматическое обновление количества участников',
    benefit4: 'События автоматически завершаются или удаляются',
  },
  landing: {
    hero: {
      title: 'RaidBot',
      subtitle: 'Управление событиями нового поколения для Discord',
      description: 'Мощный, гибкий и интуитивно понятный. Организуйте рейды, события и активности с продвинутым планированием, шаблонами и управлением участниками.',
      loginWithDiscord: 'Войти через Discord',
      adminLogin: 'Вход администратора по паролю',
      hidePasswordLogin: 'Скрыть вход по паролю',
      passwordAuthInfo: 'Вход по паролю предоставляет доступ только к панели администратора',
      username: 'Имя пользователя',
      password: 'Пароль',
      loggingIn: 'Вход...',
      login: 'Войти',
      welcomeBack: 'С возвращением',
      loggedInAs: 'Вы вошли как',
      goToDashboard: 'Перейти на панель управления',
      goToAdminPanel: 'Перейти в панель администратора',
      logout: 'Выйти',
    },
    features: {
      title: 'Мощные возможности',
      subtitle: 'Всё что нужно для организации и управления Discord событиями любого масштаба',
      eventScheduling: {
        title: 'Планирование событий',
        description: 'Создавайте события с пользовательскими датами, временем, поддержкой часовых поясов и лимитами участников. Включает календарь!',
      },
      smartParticipants: {
        title: 'Умное управление участниками',
        description: 'Запись по ролям, листы ожидания, запасная скамейка и заметки участников для лучшей организации',
      },
      eventTemplates: {
        title: 'Шаблоны событий',
        description: 'Экономьте время с переиспользуемыми шаблонами, включая роли, лимиты и пользовательские конфигурации',
      },
      reminders: {
        title: 'Напоминания и ЛС',
        description: 'Автоматические напоминания перед событиями, уведомления в ЛС и настраиваемые интервалы напоминаний',
      },
      statistics: {
        title: 'Статистика и таблицы лидеров',
        description: 'Отслеживайте участие, неявки, автороли для топ участников и детальную аналитику',
      },
      voiceChannels: {
        title: 'Автоматические голосовые каналы',
        description: 'Автоматическое создание и удаление голосовых каналов с ограничениями по участникам',
      },
      threads: {
        title: 'Управление ветками',
        description: 'Автосоздание веток для обсуждения событий с очисткой и архивированием',
      },
      multiLanguage: {
        title: 'Мультиязычность',
        description: 'Поддержка английского и русского языков с простым расширением для других языков',
      },
      webDashboard: {
        title: 'Веб-панель',
        description: 'Полнофункциональный веб-интерфейс с тёмной темой, календарём и поддержкой мобильных устройств',
      },
    },
    footer: {
      copyright: '© 2025 RaidBot',
      madeWith: 'Сделано с',
      by: 'автор',
      viewOnGithub: 'Посмотреть на GitHub',
    },
  },
  errors: {
    accessDenied: 'Доступ запрещён',
    accessDeniedEvents: 'Доступ запрещён: у вас нет прав на просмотр событий.',
    accessDeniedTemplates: 'Доступ запрещён: у вас нет прав на просмотр шаблонов.',
    accessDeniedSettings: 'Доступ запрещён: у вас нет прав на просмотр настроек.',
    loadFailed: 'Не удалось загрузить. Попробуйте ещё раз.',
    notFound: 'Не найдено',
    goToDashboard: 'Перейти на панель управления',
    botNotInGuild: {
      title: 'Бот не на сервере',
      message: 'Бот отсутствует на этом сервере. Пригласите бота, чтобы использовать панель управления.',
      inviteButton: 'Пригласить бота',
      backButton: 'Вернуться к серверам',
    },
  },
  panelSelect: {
    welcome: 'Добро пожаловать, {username}!',
    subtitle: 'Как администратор бота, у вас есть доступ к обеим панелям. Выберите, куда вы хотите перейти:',
    botAdminPanel: 'Панель администратора бота',
    botAdminDescription: 'Глобальное администрирование бота: управление всеми серверами, системными настройками и статистикой',
    botAdminFeature1: 'Доступ ко всем серверам',
    botAdminFeature2: 'Глобальный поиск и аналитика',
    botAdminFeature3: 'Системная конфигурация',
    botAdminFeature4: 'Массовые операции',
    openBotAdmin: 'Открыть админ-панель бота →',
    guildAdminPanel: 'Панель администратора сервера',
    guildAdminDescription: 'Управление вашими Discord серверами: события, шаблоны и настройки серверов',
    guildAdminFeature1: 'Только ваши серверы',
    guildAdminFeature2: 'Управление событиями',
    guildAdminFeature3: 'Создание шаблонов',
    guildAdminFeature4: 'Настройки сервера',
    chooseServer: 'Выбрать сервер →',
    backToHome: '← Вернуться на главную',
  },
  serverSelect: {
    title: 'Выберите сервер',
    subtitle: 'Выберите сервер для управления',
    loadingServers: 'Загрузка серверов...',
    error: 'Ошибка',
    noServersTitle: 'Нет доступных серверов',
    noServersDescription: 'Серверы, где вы можете управлять ботом, не найдены.',
    makeSure: 'Убедитесь, что:',
    requirement1: 'У вас есть права MANAGE_GUILD или ADMINISTRATOR',
    requirement2: 'Бот приглашён на сервер',
    serversAvailable: '{count} {plural} доступно',
    owner: '👑 Владелец',
    logout: 'Вы уверены, что хотите выйти?',
    logoutTitle: '{username} (нажмите для выхода)',
    botNotPresent: 'Бот не на сервере',
  },
};
